import feathers from '@feathersjs/feathers'
import hooks from '@/api/hooks/'
import apiUrl from '@/utils/apiUrl'
import dotEvents from '@/api/events/dots'
import providerEvents from '@/api/events/provider'

const socketio = require('@feathersjs/socketio-client')
const io = require('socket.io-client')

/* global Primus */
const socket = io(apiUrl())
// Initialize our Feathers client application through Socket.io
// with hooks and authentication.
const api = feathers()
  .configure(socketio(socket))
  .configure(hooks())

socket.on('connect', () => {
  console.log('socketID', socket.id) // an alphanumeric id...
})

/**
 * Core Services
 */

export const bootstrapService = api.service('bootstrap')

export const providerService = api.service('provider')
providerEvents(providerService)

export const pagesService = api.service('pages')
export const dotsService = api.service('dots')
dotEvents(dotsService)
dotsService.timeout = 15000

export const dotsAssignedPageService = api.service('dots-assigned-page')

export const browsersService = api.service('browsers')
export const authService = api.service('auth')
